"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var replaceErrors = function replaceErrors(key, value) {
  if (value instanceof Error) {
    var error = {};
    Object.getOwnPropertyNames(value).forEach(function (k) {
      error[k] = value[k];
    });
    return error;
  }
  return value;
};

var parse = exports.parse = JSON.parse.bind(JSON);

var stringify = exports.stringify = function stringify(obj) {
  return JSON.stringify(obj, replaceErrors);
};